import {MenuModel, UserMenuModel} from "app/model/ua/user-menu";

type MenuUtilType = UserMenuModel | MenuModel;
export default class MenuUtil {

  public static convertToList<T>(rootMenu: T) {
    const menuToCheck: T[] = [{...rootMenu, depth: 1}];
    const flatMenus: T[] = [];

    while(menuToCheck.length > 0) {
      const menu: any = {...menuToCheck.shift()};
      if(menu) {
        if(menu.subMenus && menu.subMenus.length > 0) {
          menu.subMenus.forEach((sub: T) => menuToCheck.push({...sub, depth:menu.depth === 1 ? 2 : 3}));
          delete menu.subMenus;
        }
        flatMenus.push(menu);
      }
    }
    return flatMenus;
  }

  public static findUppoMenuFromSelectMenu(menus: MenuUtilType[], menu: MenuUtilType): any {
    for(let m of menus) {
      if(m.menuId === menu.uppoMenuId) {
        return m;
      } else {
        if(m.subMenus && m.subMenus.length > 0) {
          const findUppoFromSub = this.findUppoMenuFromSelectMenu(m.subMenus, menu);
          if(findUppoFromSub) {
            return findUppoFromSub;
          }
        }
      }
    }
  }

  public static convertToFlatMenuArray(menus: MenuModel[]) {
    const flatMenuArray: MenuModel[] = [];
    for(let menu of menus) {
      flatMenuArray.push(...this.convertToList(menu));
    }
    return flatMenuArray;
  }

  public static convertToTreeMenuArray(menus: MenuModel[]) {
    const nodeMap: any = {};
    const result: MenuModel[] = [];

    menus.forEach(item => nodeMap[item.menuId!] = {...item, subMenus: []});
    menus.forEach(item => {
      const node = nodeMap[item.menuId!];
      if(item.uppoMenuId) {
        nodeMap[item.uppoMenuId!].subMenus.push(node);
      } else {
        result.push(node);
      }
    });
    return result;
  }
}